import "../styles/ReadsStyle.css"
import books from "../BookData/BookData"
import { useState } from "react";

const getStatusColor = (status) => {
    switch (status) {
        case "Read":
            return "green";
        case "To Be Read":
            return "black";
        case "In Progress":
            return "orange";
        default:
            return "gray;"
    }
};

function Reads() {
    const [filter, setFilter] = useState("all");

    const filteredBooks = 
        filter === "all"
            ? books
            :books.filter((book) => book.status === filter);

    return(
<div className="Library">
    <div className="filter-options">
 <button
    className={`sort-buttons ${filter === "all" ? "active" : ""}`}
    onClick={() => setFilter("all")}
  >
    All Books
  </button>
  <button
    className={`sort-buttons ${filter === "Read" ? "active" : ""}`}
    onClick={() => setFilter("Read")}
  >
    Read
  </button>
  <button
    className={`sort-buttons ${filter === "In Progress" ? "active" : ""}`}
    onClick={() => setFilter("In Progress")}
  >
    In Progress
  </button>
  <button
    className={`sort-buttons ${filter === "To Be Read" ? "active" : ""}`}
    onClick={() => setFilter("To Be Read")}
  >
    To Be Read
  </button>
    </div>
    
    <div className="book-list"> 
        {filteredBooks.map((book, index) => (
            <div className="book-card">
                <img src={book.cover} alt={book.title} className="book-cover"/>
                <div className="book-info">
                    <h3 style={{color: getStatusColor(book.status) }}>{book.status}</h3>
                    <h2>{book.title}</h2>
                    <h4>By: {book.author}</h4>
                    <p>Synopsis: {book.description}</p>

                    {book.status === "Read" && (
                        <>
                    <h6>My Rating: {book.tannersrating}</h6>
                    <p>My Thoughts: {book.tannersdescrption}</p>
                        </>
                    )}
                </div>
            </div>
        ))}
    </div>   
</div>



    );
}

export default Reads;